import { Injectable } from '@angular/core';
import { GbgIdentityVerification } from './models/gbg-identity-verification.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface GbgIdentityVerificationState extends EntityState<GbgIdentityVerification> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'gbg-identity-verification' })
export class GbgIdentityVerificationStore extends EntityStore<GbgIdentityVerificationState> {
  constructor() {
    super();
  }
}
